import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { URL_SERVICIOS } from '../../config/config';
import { Usuario } from '../../models/model.index';
import { UsuarioService } from '../usuario/usuario.service';
import { CookieService } from 'ngx-cookie-service';
import { map } from 'rxjs/operators';
import swal from 'sweetalert2';

@Injectable()
export class SharedService {

  usuario: Usuario;
  noti: any;
  token: string;

  constructor(
    public http: HttpClient,
    public _usuarioService: UsuarioService, 
    private _cookieService: CookieService
  ) {
    //this.cargarStorage();
  }

  /*cargarStorage() {

    if (localStorage.getItem('token')) {
      this.token = localStorage.getItem('token');
      this.usuario = JSON.parse(localStorage.getItem('usuario'));

    } else {
      this.token = '';
      this.usuario = null;

    }
  }*/

  /*====================================
  =           Notificacion             =
  ====================================*/
  crearNotificacion(noti) {

    let url = URL_SERVICIOS + '/notificacion?token=' + this._cookieService.get('token');

    return this.http.post(url, noti).pipe(
      map((resp: any) => {
        return resp.notificacion;
      }));
  }

  cargarNotificacion(id) {
    let url = URL_SERVICIOS + '/notificacion/' + id;

    return this.http.get(url);
  }

  cargarAdminNotificaciones() {
    let url = URL_SERVICIOS + '/notificacion';

    return this.http.get(url);
  }

  cargarNotificaciones( id ) {
    let url = URL_SERVICIOS + '/notificacion/profesional/' + id;
    return this.http.get(url);
  }
  
  actualizarNotificacion(noti) {

    let url = URL_SERVICIOS + '/notificacion/' + noti._id;
    url += '?token=' + this._cookieService.get('token');

    //console.log(JSON.stringify(noti));

    return this.http.put(url, noti).pipe(
      map((resp: any) => {
        //swal('Notificacion de noti actualizado', noti._id, 'success');
        return true;
      }));
  }

  /*borrarNotificacion( id: string ) {

    let url = URL_SERVICIOS + '/notificacion/' + id + '?token=' + this._usuarioService.token;

    return this.http.delete( url ).pipe(
      map( resp => {
        swal({
          type: 'success',
          title: 'Pago borrado',
          text: 'El noti se ha eliminado correctamente',
          showConfirmButton: false,
          timer: 2000
        });
        return true;
      }))
  }*/
}
